import { toast } from 'react-toastify';

export const Mensaje = (title, text, tipo = 'info') => {
  const mensaje = `${title}: ${text}`;

  if (tipo === 'success') {
    toast.success(mensaje);
    return;
  }

  if (tipo === 'error') {
    toast.error(mensaje);
    return;
  }

  toast.info(mensaje);
};
